import Warehouse from './warehouse'
export default Warehouse
